import { render, staticRenderFns } from "./reduceMoneyPopup.vue?vue&type=template&id=830e13f8&scoped=true&"
import script from "./reduceMoneyPopup.vue?vue&type=script&lang=js&"
export * from "./reduceMoneyPopup.vue?vue&type=script&lang=js&"
import style0 from "./reduceMoneyPopup.vue?vue&type=style&index=0&id=830e13f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e13f8",
  null
  
)

export default component.exports